// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file legal/v1/legal.proto (package legal.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { FieldMask, FieldMaskJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file legal/v1/legal.proto.
 */
export const file_legal_v1_legal: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_field_mask, file_google_protobuf_timestamp],
	);

/**
 * Policy represents a Terms & Conditions policy.
 *
 * @generated from message legal.v1.Policy
 */
export type Policy = Message<"legal.v1.Policy"> & {
	/**
	 * ID is the unique identifier of the policy.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * Name is the user-provided name of the policy.
	 *
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * Description is an optional description of the policy.
	 *
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * Version is the semantic version of the policy.
	 *
	 * @generated from field: string version = 4;
	 */
	version: string;

	/**
	 * OrgId is the unique identifier of the organization the policy belongs to.
	 *
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * WorkspaceId is the unique identifier of the workspace the policy belongs to.
	 *
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * FolderPath is the path of the folder the policy belongs to.
	 *
	 * @generated from field: string folder_path = 7;
	 */
	folderPath: string;

	/**
	 * FolderId is the unique identifier of the folder the policy belongs to.
	 *
	 * @generated from field: string folder_id = 8;
	 */
	folderId: string;

	/**
	 * Creator is the user subject that created the policy.
	 *
	 * @generated from field: common.v1.Creator creator = 9;
	 */
	creator?: Creator | undefined;

	/**
	 * State is the state of the policy.
	 *
	 * @generated from field: string state = 10;
	 */
	state: string;

	/**
	 * Tags is the list of tags associated with the policy.
	 *
	 * @generated from field: repeated string tags = 11;
	 */
	tags: string[];

	/**
	 * Visibility is the visibility of the policy.
	 *
	 * @generated from field: string visibility = 12;
	 */
	visibility: string;

	/**
	 * Created At is the timestamp when the policy was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * Updated At is the timestamp when the policy was last updated.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * The content of the policy
	 *
	 * @generated from field: legal.v1.PolicyContent content = 15;
	 */
	content?: PolicyContent | undefined;
};

/**
 * Policy represents a Terms & Conditions policy.
 *
 * @generated from message legal.v1.Policy
 */
export type PolicyJson = {
	/**
	 * ID is the unique identifier of the policy.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * Name is the user-provided name of the policy.
	 *
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * Description is an optional description of the policy.
	 *
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * Version is the semantic version of the policy.
	 *
	 * @generated from field: string version = 4;
	 */
	version?: string;

	/**
	 * OrgId is the unique identifier of the organization the policy belongs to.
	 *
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * WorkspaceId is the unique identifier of the workspace the policy belongs to.
	 *
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * FolderPath is the path of the folder the policy belongs to.
	 *
	 * @generated from field: string folder_path = 7;
	 */
	folderPath?: string;

	/**
	 * FolderId is the unique identifier of the folder the policy belongs to.
	 *
	 * @generated from field: string folder_id = 8;
	 */
	folderId?: string;

	/**
	 * Creator is the user subject that created the policy.
	 *
	 * @generated from field: common.v1.Creator creator = 9;
	 */
	creator?: CreatorJson;

	/**
	 * State is the state of the policy.
	 *
	 * @generated from field: string state = 10;
	 */
	state?: string;

	/**
	 * Tags is the list of tags associated with the policy.
	 *
	 * @generated from field: repeated string tags = 11;
	 */
	tags?: string[];

	/**
	 * Visibility is the visibility of the policy.
	 *
	 * @generated from field: string visibility = 12;
	 */
	visibility?: string;

	/**
	 * Created At is the timestamp when the policy was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: TimestampJson;

	/**
	 * Updated At is the timestamp when the policy was last updated.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: TimestampJson;

	/**
	 * The content of the policy
	 *
	 * @generated from field: legal.v1.PolicyContent content = 15;
	 */
	content?: PolicyContentJson;
};

/**
 * Describes the message legal.v1.Policy.
 * Use `create(PolicySchema)` to create a new message.
 */
export const PolicySchema: GenMessage<Policy, { jsonType: PolicyJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 0);

/**
 * PolicyContent is the content of the policy, may be either a url or a string.
 *
 * @generated from message legal.v1.PolicyContent
 */
export type PolicyContent = Message<"legal.v1.PolicyContent"> & {
	/**
	 * @generated from oneof legal.v1.PolicyContent.content
	 */
	content:
		| {
				/**
				 * @generated from field: string url = 1;
				 */
				value: string;
				case: "url";
		  }
		| {
				/**
				 * @generated from field: string text = 2;
				 */
				value: string;
				case: "text";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * PolicyContent is the content of the policy, may be either a url or a string.
 *
 * @generated from message legal.v1.PolicyContent
 */
export type PolicyContentJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * @generated from field: string text = 2;
	 */
	text?: string;
};

/**
 * Describes the message legal.v1.PolicyContent.
 * Use `create(PolicyContentSchema)` to create a new message.
 */
export const PolicyContentSchema: GenMessage<PolicyContent, { jsonType: PolicyContentJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 1);

/**
 * CreatePolicyRequest is the request message for the CreatePolicy RPC.
 *
 * @generated from message legal.v1.CreatePolicyRequest
 */
export type CreatePolicyRequest = Message<"legal.v1.CreatePolicyRequest"> & {
	/**
	 * Name is the user-provided name of the policy.
	 *
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * Description is an optional description of the policy.
	 *
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * OrgId is the unique identifier of the organization the policy belongs to.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * WorkspaceId is the unique identifier of the workspace the policy belongs to.
	 *
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * FolderPath is the path of the folder the policy belongs to.
	 *
	 * @generated from field: string folder_path = 6;
	 */
	folderPath: string;

	/**
	 * Tags is the list of tags associated with the policy.
	 *
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * The content of the policy
	 *
	 * @generated from field: legal.v1.PolicyContent content = 8;
	 */
	content?: PolicyContent | undefined;
};

/**
 * CreatePolicyRequest is the request message for the CreatePolicy RPC.
 *
 * @generated from message legal.v1.CreatePolicyRequest
 */
export type CreatePolicyRequestJson = {
	/**
	 * Name is the user-provided name of the policy.
	 *
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * Description is an optional description of the policy.
	 *
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * OrgId is the unique identifier of the organization the policy belongs to.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * WorkspaceId is the unique identifier of the workspace the policy belongs to.
	 *
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * FolderPath is the path of the folder the policy belongs to.
	 *
	 * @generated from field: string folder_path = 6;
	 */
	folderPath?: string;

	/**
	 * Tags is the list of tags associated with the policy.
	 *
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * The content of the policy
	 *
	 * @generated from field: legal.v1.PolicyContent content = 8;
	 */
	content?: PolicyContentJson;
};

/**
 * Describes the message legal.v1.CreatePolicyRequest.
 * Use `create(CreatePolicyRequestSchema)` to create a new message.
 */
export const CreatePolicyRequestSchema: GenMessage<CreatePolicyRequest, { jsonType: CreatePolicyRequestJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 2);

/**
 * CreatePolicyResponse is the response message for the CreatePolicy RPC.
 *
 * @generated from message legal.v1.CreatePolicyResponse
 */
export type CreatePolicyResponse = Message<"legal.v1.CreatePolicyResponse"> & {
	/**
	 * @generated from field: legal.v1.Policy policy = 1;
	 */
	policy?: Policy | undefined;
};

/**
 * CreatePolicyResponse is the response message for the CreatePolicy RPC.
 *
 * @generated from message legal.v1.CreatePolicyResponse
 */
export type CreatePolicyResponseJson = {
	/**
	 * @generated from field: legal.v1.Policy policy = 1;
	 */
	policy?: PolicyJson;
};

/**
 * Describes the message legal.v1.CreatePolicyResponse.
 * Use `create(CreatePolicyResponseSchema)` to create a new message.
 */
export const CreatePolicyResponseSchema: GenMessage<CreatePolicyResponse, { jsonType: CreatePolicyResponseJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 3);

/**
 * UpdatePolicyRequest is the request message for the UpdatePolicy RPC.
 *
 * @generated from message legal.v1.UpdatePolicyRequest
 */
export type UpdatePolicyRequest = Message<"legal.v1.UpdatePolicyRequest"> & {
	/**
	 * @generated from field: legal.v1.Policy policy = 1;
	 */
	policy?: Policy | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * UpdatePolicyRequest is the request message for the UpdatePolicy RPC.
 *
 * @generated from message legal.v1.UpdatePolicyRequest
 */
export type UpdatePolicyRequestJson = {
	/**
	 * @generated from field: legal.v1.Policy policy = 1;
	 */
	policy?: PolicyJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message legal.v1.UpdatePolicyRequest.
 * Use `create(UpdatePolicyRequestSchema)` to create a new message.
 */
export const UpdatePolicyRequestSchema: GenMessage<UpdatePolicyRequest, { jsonType: UpdatePolicyRequestJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 4);

/**
 * UpdatePolicyResponse is the response message for the UpdatePolicy RPC.
 *
 * @generated from message legal.v1.UpdatePolicyResponse
 */
export type UpdatePolicyResponse = Message<"legal.v1.UpdatePolicyResponse"> & {
	/**
	 * @generated from field: legal.v1.Policy policy = 1;
	 */
	policy?: Policy | undefined;
};

/**
 * UpdatePolicyResponse is the response message for the UpdatePolicy RPC.
 *
 * @generated from message legal.v1.UpdatePolicyResponse
 */
export type UpdatePolicyResponseJson = {
	/**
	 * @generated from field: legal.v1.Policy policy = 1;
	 */
	policy?: PolicyJson;
};

/**
 * Describes the message legal.v1.UpdatePolicyResponse.
 * Use `create(UpdatePolicyResponseSchema)` to create a new message.
 */
export const UpdatePolicyResponseSchema: GenMessage<UpdatePolicyResponse, { jsonType: UpdatePolicyResponseJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 5);

/**
 * GetPolicyRequest is the request message for the GetPolicy RPC.
 *
 * @generated from message legal.v1.GetPolicyRequest
 */
export type GetPolicyRequest = Message<"legal.v1.GetPolicyRequest"> & {
	/**
	 * Id is the unique identifier of the policy to retrieve.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * GetPolicyRequest is the request message for the GetPolicy RPC.
 *
 * @generated from message legal.v1.GetPolicyRequest
 */
export type GetPolicyRequestJson = {
	/**
	 * Id is the unique identifier of the policy to retrieve.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message legal.v1.GetPolicyRequest.
 * Use `create(GetPolicyRequestSchema)` to create a new message.
 */
export const GetPolicyRequestSchema: GenMessage<GetPolicyRequest, { jsonType: GetPolicyRequestJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 6);

/**
 * @generated from message legal.v1.GetPolicyResponse
 */
export type GetPolicyResponse = Message<"legal.v1.GetPolicyResponse"> & {
	/**
	 * @generated from field: legal.v1.Policy policy = 1;
	 */
	policy?: Policy | undefined;
};

/**
 * @generated from message legal.v1.GetPolicyResponse
 */
export type GetPolicyResponseJson = {
	/**
	 * @generated from field: legal.v1.Policy policy = 1;
	 */
	policy?: PolicyJson;
};

/**
 * Describes the message legal.v1.GetPolicyResponse.
 * Use `create(GetPolicyResponseSchema)` to create a new message.
 */
export const GetPolicyResponseSchema: GenMessage<GetPolicyResponse, { jsonType: GetPolicyResponseJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 7);

/**
 * ListPoliciesRequest is the request message for the ListPolicies RPC.
 *
 * @generated from message legal.v1.ListPoliciesRequest
 */
export type ListPoliciesRequest = Message<"legal.v1.ListPoliciesRequest"> & {
	/**
	 * OrgId is the unique identifier of the organization the policies belong to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Filter contains filter arguments for listing policies.
	 *
	 * @generated from field: legal.v1.PolicyFilter filter = 2;
	 */
	filter?: PolicyFilter | undefined;

	/**
	 * Pagination contains pagination arguments for listing policies.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * ListPoliciesRequest is the request message for the ListPolicies RPC.
 *
 * @generated from message legal.v1.ListPoliciesRequest
 */
export type ListPoliciesRequestJson = {
	/**
	 * OrgId is the unique identifier of the organization the policies belong to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Filter contains filter arguments for listing policies.
	 *
	 * @generated from field: legal.v1.PolicyFilter filter = 2;
	 */
	filter?: PolicyFilterJson;

	/**
	 * Pagination contains pagination arguments for listing policies.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message legal.v1.ListPoliciesRequest.
 * Use `create(ListPoliciesRequestSchema)` to create a new message.
 */
export const ListPoliciesRequestSchema: GenMessage<ListPoliciesRequest, { jsonType: ListPoliciesRequestJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 8);

/**
 * PolicyFilter is the filter for listing policies.
 *
 * @generated from message legal.v1.PolicyFilter
 */
export type PolicyFilter = Message<"legal.v1.PolicyFilter"> & {
	/**
	 * WorkspaceId is the unique identifier of the workspace the policies belong to.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * FolderPath is the path of the folder the policies belong to.
	 *
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * CreatorId filters policies created by the specified user subject.
	 *
	 * @generated from field: string creator_id = 4;
	 */
	creatorId: string;

	/**
	 * NamePrefix filters policies whose names start with the specified prefix.
	 *
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix: string;

	/**
	 * Tags filters policies that contain all the specified tags.
	 *
	 * @generated from field: repeated string tags = 6;
	 */
	tags: string[];

	/**
	 * Visibilities filters policies to the specified asset visibilities.
	 *
	 * @generated from field: repeated string visibilities = 7;
	 */
	visibilities: string[];

	/**
	 * States filters policies to the specified asset states.
	 *
	 * @generated from field: repeated string states = 8;
	 */
	states: string[];
};

/**
 * PolicyFilter is the filter for listing policies.
 *
 * @generated from message legal.v1.PolicyFilter
 */
export type PolicyFilterJson = {
	/**
	 * WorkspaceId is the unique identifier of the workspace the policies belong to.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * FolderPath is the path of the folder the policies belong to.
	 *
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * CreatorId filters policies created by the specified user subject.
	 *
	 * @generated from field: string creator_id = 4;
	 */
	creatorId?: string;

	/**
	 * NamePrefix filters policies whose names start with the specified prefix.
	 *
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix?: string;

	/**
	 * Tags filters policies that contain all the specified tags.
	 *
	 * @generated from field: repeated string tags = 6;
	 */
	tags?: string[];

	/**
	 * Visibilities filters policies to the specified asset visibilities.
	 *
	 * @generated from field: repeated string visibilities = 7;
	 */
	visibilities?: string[];

	/**
	 * States filters policies to the specified asset states.
	 *
	 * @generated from field: repeated string states = 8;
	 */
	states?: string[];
};

/**
 * Describes the message legal.v1.PolicyFilter.
 * Use `create(PolicyFilterSchema)` to create a new message.
 */
export const PolicyFilterSchema: GenMessage<PolicyFilter, { jsonType: PolicyFilterJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 9);

/**
 * ListPoliciesResponse is the response message for the ListPolicies RPC.
 *
 * @generated from message legal.v1.ListPoliciesResponse
 */
export type ListPoliciesResponse = Message<"legal.v1.ListPoliciesResponse"> & {
	/**
	 * Policies is the list of policies.
	 *
	 * @generated from field: repeated legal.v1.Policy policies = 1;
	 */
	policies: Policy[];

	/**
	 * Pagination contains pagination information about the current listing.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListPoliciesResponse is the response message for the ListPolicies RPC.
 *
 * @generated from message legal.v1.ListPoliciesResponse
 */
export type ListPoliciesResponseJson = {
	/**
	 * Policies is the list of policies.
	 *
	 * @generated from field: repeated legal.v1.Policy policies = 1;
	 */
	policies?: PolicyJson[];

	/**
	 * Pagination contains pagination information about the current listing.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message legal.v1.ListPoliciesResponse.
 * Use `create(ListPoliciesResponseSchema)` to create a new message.
 */
export const ListPoliciesResponseSchema: GenMessage<ListPoliciesResponse, { jsonType: ListPoliciesResponseJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 10);

/**
 * DeletePolicyRequest is the request message for the DeletePolicy RPC.
 *
 * @generated from message legal.v1.DeletePolicyRequest
 */
export type DeletePolicyRequest = Message<"legal.v1.DeletePolicyRequest"> & {
	/**
	 * Id is the unique identifier of the policy to delete.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * DeletePolicyRequest is the request message for the DeletePolicy RPC.
 *
 * @generated from message legal.v1.DeletePolicyRequest
 */
export type DeletePolicyRequestJson = {
	/**
	 * Id is the unique identifier of the policy to delete.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message legal.v1.DeletePolicyRequest.
 * Use `create(DeletePolicyRequestSchema)` to create a new message.
 */
export const DeletePolicyRequestSchema: GenMessage<DeletePolicyRequest, { jsonType: DeletePolicyRequestJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 11);

/**
 * DeletePolicyResponse is the response message for the DeletePolicy RPC.
 *
 * @generated from message legal.v1.DeletePolicyResponse
 */
export type DeletePolicyResponse = Message<"legal.v1.DeletePolicyResponse"> & {};

/**
 * DeletePolicyResponse is the response message for the DeletePolicy RPC.
 *
 * @generated from message legal.v1.DeletePolicyResponse
 */
export type DeletePolicyResponseJson = {};

/**
 * Describes the message legal.v1.DeletePolicyResponse.
 * Use `create(DeletePolicyResponseSchema)` to create a new message.
 */
export const DeletePolicyResponseSchema: GenMessage<DeletePolicyResponse, { jsonType: DeletePolicyResponseJson }> = /*@__PURE__*/ messageDesc(file_legal_v1_legal, 12);

/**
 * LegalService is the service for managing terms and conditions policies.
 *
 * @generated from service legal.v1.LegalService
 */
export const LegalService: GenService<{
	/**
	 * CreatePolicy creates a new terms and conditions policy.
	 *
	 * @generated from rpc legal.v1.LegalService.CreatePolicy
	 */
	createPolicy: {
		methodKind: "unary";
		input: typeof CreatePolicyRequestSchema;
		output: typeof CreatePolicyResponseSchema;
	};
	/**
	 * UpdatePolicy updates an existing terms and conditions policy based on the provided field mask.
	 *
	 * @generated from rpc legal.v1.LegalService.UpdatePolicy
	 */
	updatePolicy: {
		methodKind: "unary";
		input: typeof UpdatePolicyRequestSchema;
		output: typeof UpdatePolicyResponseSchema;
	};
	/**
	 * ListPolicies lists terms and conditions policies with optional filtering and pagination.
	 *
	 * @generated from rpc legal.v1.LegalService.ListPolicies
	 */
	listPolicies: {
		methodKind: "unary";
		input: typeof ListPoliciesRequestSchema;
		output: typeof ListPoliciesResponseSchema;
	};
	/**
	 * GetPolicy retrieves a specific terms and conditions policy by its ID and optional version.
	 *
	 * @generated from rpc legal.v1.LegalService.GetPolicy
	 */
	getPolicy: {
		methodKind: "unary";
		input: typeof GetPolicyRequestSchema;
		output: typeof GetPolicyResponseSchema;
	};
	/**
	 * DeletePolicy deletes a specific terms and conditions policy by its ID.
	 *
	 * @generated from rpc legal.v1.LegalService.DeletePolicy
	 */
	deletePolicy: {
		methodKind: "unary";
		input: typeof DeletePolicyRequestSchema;
		output: typeof DeletePolicyResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_legal_v1_legal, 0);
